import React from 'react';
import {Select} from 'antd';
import {connect} from 'react-redux';
import AjaxAction from '../../actions/AjaxAction.js';
import {debounce} from '../../util/func';
import ajaxUtil from '../../util/ajax';

const {ajax, DOMAIN_CURRENT} = ajaxUtil;

class UserSelect extends React.Component {

    constructor(props) {
      super(props);

      this.debounceSearch = debounce(this.onSearch, 800, false);
    }

    static defaultProps = {

    };

    state = {
        list:[]
    };

    getList() {
        // var now = Date.now();
        // if(now > ((UserSelect.cache.expires||0) + 30)) {
        //     let {dispatch,filter} = this.props;
        //     filter = Object.assign({
        //         trash:0
        //     }, filter);
        //     if(filter.oper) {
        //         var oper = [].concat(filter.oper);
        //         delete filter.oper;
        //
        //         filter['#oper'] = "test(oper,'"+oper.join('|')+"')";
        //     }
        //     dispatch(AjaxAction.users(filter ? {
        //         key:JSON.stringify(filter),
        //         pagesize:650
        //     } : {
        //         pagesize:650
        //     })).then(data=>{
        //         this.setState({
        //             list:data.data
        //         });
        //
        //         UserSelect.cache = {
        //             expires:Date.now(),
        //             list:data.data
        //         };
        //     });
        // }else {
        //     this.setState({
        //         list:UserSelect.cache.list
        //     });
        // }
    }

    componentDidMount() {
      console.log(`fetch user`);
      this.checkUpdateUser(this.props.value);
    }

    componentWillReceiveProps(nextProps) {
      console.log(`fetch user will props`);
      if(nextProps && nextProps.value) {
        this.checkUpdateUser(nextProps.value);
      }
    }

    checkUpdateUser = (value)=>{
      // 如果没有内容
      let array = (value || "").split(',') || [];

      if(this.state.list && this.state.list.length < 1) {
        this.updateDefaultValue(array);
      }else {
        // 如果本身列表里没有这个用户，则需要去请求
        let flag = true;

        for(var i=0;i<this.state.list.length;i++) {
          if(array.indexOf(this.state.list[i].id) > -1) {
            flag = false;
            break;
          }
        }

        if(flag) {
          this.updateDefaultValue(array);
        }
      }
    }

    updateDefaultValue = (target)=>{
      let value = target ? target : [];
      value.forEach(it=>{
        this.onSearch(it);
      });
    }

    onSearch = (e)=>{
      let {filter} = this.props;
      let key = {};
      if(filter) {
        if(filter.oper) {
            var oper = [].concat(filter.oper);
            delete filter.oper;
            filter['#oper'] = "test(oper,'"+oper.join('|')+"')";
        }
        key = {
          ...key,
          ...filter
        }
      }
      ajax({
        url:DOMAIN_CURRENT + '/api/user',
        data:{
          search:e,
          key:JSON.stringify(key),
          pagesize:10,
          page:1
        }
      }).then(res=>{
        this.setState({
          list:(res && res.data) || []
        })
      })
    }

    renderOptions() {
        return this.state.list.map(item=>{
            return <Select.Option key={String(item.id)} value={item.id}>{item.nickname+'/'+item.phone}</Select.Option>;
        });
    }

    render() {
        let value = this.props.value ? this.props.value.split(",") : [];
        let {single} = this.props;
        return <Select
            mode={single ? "single" : "multiple"} style={{ width: '100%' }}
            placeholder="请输入姓名"
            filterOption={false}
            onChange={this.props.onChange}
            onSearch={this.debounceSearch}
            disabled={this.props.disabled}
            showSearch={true}
            defaultActiveFirstOption={false}
            showArrow={false}
            notFoundContent={null}
            value={value}>
            {this.renderOptions()}
        </Select>;
    }
}

UserSelect.cache = {

};

export default connect((state) => ({
}))(UserSelect);



// WEBPACK FOOTER //
// ./src/components/Select/UserSelect.js